export default function Footer() {
  return (
    <div className="footer-container">
      <div className="footer-wrapper">
        Copyright © 2018 - 2025 All rights reversed || Powered By Advanced ERP
        USA
      </div>
    </div>
  );
}
